import { render, staticRenderFns } from "./TabAnalisiClienti.vue?vue&type=template&id=5e0366c4&"
import script from "./TabAnalisiClienti.vue?vue&type=script&lang=js&"
export * from "./TabAnalisiClienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports